
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path);
}


/**
 * 6~16位，不包含空格
 * @returns 
 */
export function loginPassworValidate(str) {
    return /^[^\s]{6,16}$/.test(str);
}


export function _isEmpty(input) {
    return String(input) === 'null' || String(input) === 'undefined' || input === '';
}

/**
 * 密码验证
 * 密码规则：密码长度8-16位，不能包含空格，必须同时包含小写字母、大写字母和数字,可有特殊字符；8 到 16 位，不允许空格，必须至少包含字母、数字、特殊字符中的两类；
 * @param {*} str 
 * @returns 
 */
export function passwordValidate(str) {
    const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^\s]{8,16}$/;
    return reg.test(str);
}

/**
 * 输入文本格式限制
 * 以数字字母下划线开头，可以包含下划线，点和空格，逗号，加号和中划线存在
 * @param {*} str
 * @returns
 */
export function inputTextValidateSpecial(str) {
    const reg = /^[a-zA-Z_][a-zA-Z0-9_.,+ -]*$/;
    return reg.test(str);
}